import { useLocation } from "react-router-dom";

import { useFileRecordDetails } from "../../../common/hooks/useFileRecordDetails";

export const useSourceFileRecordDetails = () => {
    const { search } = useLocation();
    const sourceFileRecordId = new URLSearchParams(search).get("sourceFileRecordId") ?? "";

    return useFileRecordDetails(sourceFileRecordId);
};
